import { HelperResult, JobPreference } from '@openclassrooms/sdk-web';
import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { clientApi } from '../../configuration';

interface GetJobPreferenceParams {
  userId: number;
}

interface UpdateJobPreferenceParams {
  userId: number;
  context: string;
}

interface UpdateJobPreferenceBody extends JobPreference {}

const { useGet: useJobPreference, useUpdate: useUpdateJobPreference } = getCRUDHooks({
  entityName: 'JobPreference',
  get: ({ userId }: GetJobPreferenceParams): HelperResult<JobPreference> =>
    clientApi.getOCClient().helpers.user.users.id(userId).jobPreference.find(),
  update: (
    body: UpdateJobPreferenceBody,
    { userId, context }: UpdateJobPreferenceParams
  ): HelperResult<JobPreference> =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .jobPreference.update('', body, false)
      .setHeader('X-Request-Context', context)
      .execute(),
});

export { useJobPreference, useUpdateJobPreference };
